import React, { useState, useEffect } from 'react';
import { MDBSideNavCollapse, MDBSideNavItem, MDBSideNavLink, MDBSelect } from 'mdb-react-ui-kit';
import { fetchLegislatures } from '../../../../utils/legislaturesOperations';

const Legislature = ({userSelectedLegislature, setUserSelectedLegislature}) => {
    const [collapse, setCollapse] = useState(false);
    const [legislatures, setLegislatures] = useState([]);

    useEffect(() => {
        const loadLegislatures = async () => {
            try {
                const data = await fetchLegislatures();
                const options = data
                    .filter(legislature => legislature.ordinals !== "68") // temporary filter to exclude 68th Legislature (Suzi requested)
                    .map(legislature => ({
                        text: `${legislature.ordinals} Legislature`,
                        value: legislature.id
                    }));
                setLegislatures(options);
            } catch (error) {
                console.error('Error loading legislatures:', error);
            }
        };
        loadLegislatures();
    }, []);

    const handleLegislatureChange = (value) => {
      setUserSelectedLegislature(value);
      setCollapse(false);
    };

    return (
        <MDBSideNavItem>
            <MDBSideNavLink icon='angle-down' shouldBeExpanded={collapse} onClick={() => setCollapse(!collapse)}>
                Legislature
            </MDBSideNavLink>
            <MDBSideNavCollapse open={collapse}>
                <div className="p-3">
                    <MDBSelect
                        data={legislatures}
                        onChange={(value) => handleLegislatureChange(value)}
                        label="Select Legislature"
                        value={userSelectedLegislature}
                    />
                </div>
            </MDBSideNavCollapse>
        </MDBSideNavItem>
    );
};

export default Legislature;